/* istanbul ignore file - better tested visually */

import { Outline } from '@react-three/postprocessing';
import { BlendFunction } from 'postprocessing';
import { Object3D } from 'three';

type HighlightProps = {
  selection?: Object3D | Object3D[];
  selectionLayer?: number;
  color?: number;
};

export function Highlight({ selection, selectionLayer, color = 0xfce239 }: Readonly<HighlightProps>) {
  return (
    <Outline
      selection={selection}
      selectionLayer={selectionLayer}
      blur
      blendFunction={BlendFunction.ALPHA}
      edgeStrength={10}
      visibleEdgeColor={color}
      hiddenEdgeColor={color}
    />
  );
}
